import { http, HttpResponse } from "msw";
let streamDestinations = [
    "192.168.1.100:5000",
    "192.168.100.200:6000"
];
const handlers = [
    http.get("/api/admin/stream-destinations", ()=>{
        return HttpResponse.json(streamDestinations);
    }),
    http.put("/api/admin/stream-destinations", async ({ request })=>{
        try {
            const body = await request.json();
            if (!body.destinations) {
                return new HttpResponse(JSON.stringify({
                    error: "destinations is required"
                }), {
                    status: 400
                });
            }
            const newDestinations = body.destinations.map((d)=>`${d.ip}:${d.port}`);
            const allDestsSet = new Set([
                "127.0.0.1:13372",
                ...newDestinations
            ]);
            const allDests = Array.from(allDestsSet);
            streamDestinations = allDests.filter((d)=>d !== "127.0.0.1:13372");
            const responseDestinations = allDests.map((dest)=>{
                const [ip, port] = dest.split(":");
                return {
                    ip: ip,
                    port: parseInt(port, 10)
                };
            });
            return HttpResponse.json({
                destinations: responseDestinations
            });
        } catch (error) {
            return new HttpResponse(JSON.stringify({
                error: "Failed to complete the update process"
            }), {
                status: 500
            });
        }
    }),
    http.delete("/api/admin/stream-destinations/:addr", ({ params })=>{
        const addr = params["addr"];
        const decodedAddr = decodeURIComponent(addr);
        const index = streamDestinations.indexOf(decodedAddr);
        if (index === -1) {
            return new HttpResponse(JSON.stringify({
                error: `Destination not found: ${decodedAddr}`
            }), {
                status: 404
            });
        }
        streamDestinations = streamDestinations.filter((dest)=>dest !== decodedAddr);
        return HttpResponse.json({
            success: true,
            message: null
        });
    })
];
export default handlers;
